export default __webpack_public_path__ + "static/media/v12.d9b43d02.svg";